"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvidenceVotePolaritySchema = exports.EvidenceVotePolarity = exports.EvidenceLocatorKindSchema = exports.EvidenceLocatorKind = exports.EvidenceVoteKindSchema = exports.EvidenceVoteKind = void 0;
const z = require("zod");
var EvidenceVoteKind;
(function (EvidenceVoteKind) {
    EvidenceVoteKind["Tag"] = "tag";
    EvidenceVoteKind["Link"] = "link";
})(EvidenceVoteKind || (exports.EvidenceVoteKind = EvidenceVoteKind = {}));
exports.EvidenceVoteKindSchema = z.nativeEnum(EvidenceVoteKind);
var EvidenceLocatorKind;
(function (EvidenceLocatorKind) {
    EvidenceLocatorKind["File"] = "file";
    EvidenceLocatorKind["Page"] = "page";
    EvidenceLocatorKind["Element"] = "element";
    EvidenceLocatorKind["Row"] = "row";
    EvidenceLocatorKind["Chunk"] = "chunk";
})(EvidenceLocatorKind || (exports.EvidenceLocatorKind = EvidenceLocatorKind = {}));
exports.EvidenceLocatorKindSchema = z.nativeEnum(EvidenceLocatorKind);
var EvidenceVotePolarity;
(function (EvidenceVotePolarity) {
    EvidenceVotePolarity[EvidenceVotePolarity["For"] = 1] = "For";
    EvidenceVotePolarity[EvidenceVotePolarity["Against"] = -1] = "Against";
    EvidenceVotePolarity[EvidenceVotePolarity["Withdrawn"] = 0] = "Withdrawn";
})(EvidenceVotePolarity || (exports.EvidenceVotePolarity = EvidenceVotePolarity = {}));
exports.EvidenceVotePolaritySchema = z.nativeEnum(EvidenceVotePolarity);
//# sourceMappingURL=evidence-vote.types.js.map